import React from 'react';

import Title from './index';
import type { SectionTitleProps } from './types';

export const DEFAULT_RENDER_TITLE = (props: SectionTitleProps) => <Title {...props} />;
